import { render, staticRenderFns } from "./CreateUserProfileForm.vue?vue&type=template&id=42cea6ee&"
import script from "./CreateUserProfileForm.vue?vue&type=script&lang=js&"
export * from "./CreateUserProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports